/*
 * @Description:
 * @Date: 2020-12-14 17:07:54
 */
import { Message, MessageBox } from 'element-ui';

/**
 * @description:
 * @param {Object}  提交参数
 * @param {Function}  提交接口
 * @param {String} 关键校验字段
 * @param {String} 文件名初始值
 * @param {String} 关键校验字段校验错误提示
 * @return {*}
 */
export default function(
  query,
  sendAjax,
  key,
  inputValue = new Date().getTime(),
  errorMsg = '请选择需要下载内容'
) {
  if (key && !query[key]) {
    Message({
      type: 'error',
      message: errorMsg
    });
    return false;
  }
  // 提交数据
  let sendData = { ...query };
  MessageBox.prompt('自定义文件名', '下载回单', {
    closeOnClickModal: false,
    confirmButtonText: '保存',
    showCancelButton: false,
    inputErrorMessage: '请填写4~100位字符（汉字、数字、英文、-、_）做为文件名',
    inputValue: inputValue.replace(/\s/g, ''),
    inputPattern: /^[A-Za-z0-9\u4E00-\u9FA5-_:]{4,100}$/,
    async beforeClose(action, instance, done) {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true;
        instance.confirmButtonText = '执行中...';
        let data = {
          ...sendData,
          zipName: instance.inputValue,
          downloadName: instance.inputValue
        };
        try {
          await sendAjax(data);
          done();
        } catch (e) {
          console.error(e);
        }
        instance.confirmButtonText = '保存';
        instance.confirmButtonLoading = false;
      } else {
        done();
      }
    }
  })
    .then(async () => {
      MessageBox.confirm(
        '文件已经在下载中心内进行生成,如需下载请前往下载中心',
        '',
        {
          showCancelButton: false,
          showConfirmButton: false
        }
      ).then(() => {});
    })
    .catch(() => {});
}
